import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { BarChart3, Bell, FileText, Megaphone, Smartphone, Truck, Users } from 'lucide-react';
import { PUSH_HUB_TABS } from '../../../models/MasterAdmin/pushNotificationHub';
import { pushSubNavClass, pushSubNavItem } from './pushHubUi';

const TAB_ICONS: Record<string, React.ReactNode> = {
  campaigns: <Megaphone className="h-5 w-5" />,
  templates: <FileText className="h-5 w-5" />,
  recipients: <Users className="h-5 w-5" />,
  'fcm-tokens': <Smartphone className="h-5 w-5" />,
  delivery: <Truck className="h-5 w-5" />,
  analytics: <BarChart3 className="h-5 w-5" />,
};

const PushSidebar: React.FC = () => {
  const location = useLocation();

  return (
    <aside className={pushSubNavClass} aria-label="Push notification modules">
      <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-xl bg-blue-600/15 text-blue-600 dark:text-blue-400">
        <Bell className="h-5 w-5" />
      </div>
      {PUSH_HUB_TABS.map((tab) => {
        const active =
          tab.id === 'campaigns'
            ? location.pathname === tab.path ||
              location.pathname === `${tab.path}/` ||
              location.pathname === `${tab.path}/campaigns` ||
              location.pathname.startsWith(`${tab.path}/campaigns/`)
            : location.pathname.startsWith(tab.path);
        return (
          <NavLink key={tab.id} to={tab.path} title={tab.label} className={pushSubNavItem(active)}>
            {TAB_ICONS[tab.id]}
          </NavLink>
        );
      })}
    </aside>
  );
};

export default PushSidebar;
